import React, { useCallback, useEffect, useState } from "react";
import Search from "components/Search";
import Dashboard from "components/Template/Dashboard";
import { listGroup } from "services/group";
import Loading from "components/Loading";
import NoData from "components/NoData";
import TableGroups from "./TableGroups";

type Props = {};

const GroupManagementIndex: React.FC<Props> = (): JSX.Element => {
  const [dataList, setDataList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("asc");

  const list = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await listGroup(search);
      setDataList(data);
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  }, [search]);

  useEffect(() => {
    list();
  }, [list]);

  return (
    <Dashboard
      title={"Manage Families"}
      breadcrumb={[]}
      info={dataList.length}
      subInfo={"Groups"}
      search={true}
      searchChildren={
        <Search
          placeholder={"Search for name or email"}
          value={search}
          onChange={(e: any) => setSearch(e.target.value)}
        />
      }
      children={
        <>
          <Loading loading={loading} />
          {dataList.length ? (
            <TableGroups
              dataList={dataList}
              setDataList={setDataList}
              status={status}
              setStatus={setStatus}
            />
          ) : (
            <NoData />
          )}
        </>
      }
    />
  );
};

export default GroupManagementIndex;
